import {
  VabsCreateBsbPaymentInput,
  VabsCreateIfscPaymentInput,
  VabsCreateInnerPaymentInput,
  VabsCreateSwiftPaymentInput,
  VabsPaymentSystem,
} from '@/shared/api';

export interface ICreatePaymentPayload {
  paymentSystem: VabsPaymentSystem;
  input:
    | VabsCreateSwiftPaymentInput
    | VabsCreateBsbPaymentInput
    | VabsCreateIfscPaymentInput;
}

export interface ICreateInnerPayload {
  paymentSystem: VabsPaymentSystem;
  input: VabsCreateInnerPaymentInput;
}

export const FIELD_NAMES = {
  //TODO: actual VabsPaymentSystem
  SWIFT: {
    accountNumber: 'Account number (IBAN)',
    bankCode: 'Bank BIC/SWIFT',
  },
  ACH: {
    accountNumber: 'Account number',
    bankCode: 'Routing number (ACH/Wire)',
  },
  Wire: {
    accountNumber: 'Account number',
    bankCode: 'Routing number (ACH/Wire)',
  },
  BSB: {
    accountNumber: 'Account number',
    bankCode: 'BSB number',
  },
  IFSC: {
    accountNumber: 'Account number',
    bankCode: 'Bank code',
  },
  INNER: {
    accountNumber: 'Account number',
    bankCode: 'Bank code',
  },
};
